import { message } from "antd";
import { uploadData } from "aws-amplify/storage";
import SequentialMessageNotifier from "./SequentialMessageNotifier";
import Papa from 'papaparse';

export const reusableSubmitValidator = (formType, postRequest, putRequest, form) => {
    if (formType === 'create') {
        return form
            .validateFields()
            .then(validateFields => {
                postRequest(validateFields);
            })
            .catch(error => {
                if(error.response) {
                    if(error.response.data.ModelState) {
                        let obj = error.response.data.ModelState;
                        SequentialMessageNotifier(formType, 'error', obj);
                    } else if (error.response.data.Message) {
                        SequentialMessageNotifier(formType, 'error', error.response.data.Message);
                    }
                }
            });
    } else if (formType === 'edit') {
        return form
            .validateFields()
            .then(validateFields => {
                putRequest(validateFields)
            })
            .catch(error => {
                if(error.response) {
                    if(error.response.data.ModelState) {
                        let obj = error.response.data.ModelState;
                        SequentialMessageNotifier(formType, 'error', obj);
                    } else if (error.response.data.Message) {
                        SequentialMessageNotifier(formType, 'error', error.response.data.Message);
                    }
                }
            });
    }
}

export const reusableSubmitValidatorWithKeys = (createFormKeys, editFormKeys, formType, postRequest, putRequest, form) => {
    if (formType === 'create') {
        return form
            .validateFields(createFormKeys)
            .then(validateFields => {
                postRequest(validateFields);
            })
            .catch(error => {
                if(error.response) {
                    if(error.response.data.ModelState) {
                        let obj = error.response.data.ModelState;
                        SequentialMessageNotifier(formType, 'error', obj);
                    } else if (error.response.data.Message) {
                        SequentialMessageNotifier(formType, 'error', error.response.data.Message);
                    }
                }
            });
    } else if (formType === 'edit') {
        return form
            .validateFields(editFormKeys)
            .then(validateFields => {
                putRequest(validateFields)
            })
            .catch(error => {
                if(error.response) {
                    if(error.response.data.ModelState) {
                        let obj = error.response.data.ModelState;
                        SequentialMessageNotifier(formType, 'error', obj);
                    } else if (error.response.data.Message) {
                        SequentialMessageNotifier(formType, 'error', error.response.data.Message);
                    }
                }
            });
    }
}

export const handleSPOE = (value) => {
    if(value === 0){
        return 'J'
    } else {
        return 'G'
    }
}

export const handleDiscipline = (value) => {
    switch(value){
        case 0:
            return 'None';
        case 1:
            return 'Physical Therapist';
        case 2:
            return 'Physical Therapist Assistant';
        case 3:
            return 'Occupational Therapist';
        case 4:
            return 'Certified Occupational Therapist';
        case 5:
            return 'Developmental Therapist';
        case 6:
            return 'Developmental Therapy Assistant';
        case 7:
            return 'Speech-Language Pathologist';
        case 8:
            return 'Speech-Language Pathologist Clinical Fellowship';
        case 9:
            return 'Registered Nurse';
        case 10:
            return 'Social Worker';
        case 11:
            return 'Behavioralist';
        case 12:
            return 'Psychologist';
        case 13:
            return 'Student';
        default:
            return 'Unknown';
    }
}

export const disciplineTransform = value => {
    const map = {
        0: "None",
        1: "Physical Therapist",
        2: "Physical Therapist Assistant", 
        3: "Occupational Therapist", 
        4: "Certified Occupational Therapist",
        5: "Developmental Therapist", 
        6: "Developmental Therapy Assistant", 
        7: "Speech-Language Pathologist", 
        8: "Speech-Language Pathologist Clinical Fellowship", 
        9: "Registered Nurse", 
        10: "Social Worker", 
        11: "Behavioralist", 
        12: "Psychologist", 
        13: "Student"
    };

    return map[value] ?? value;
}

export const virtualTransform = value => {
    const map = {
        0: "Virtual Only",
        1: "Open to Virtual",
        2: "No Virtual",
        3: "Ineligible"
    }

    return map[value] ?? value;
}

export const countyTransform = value => {
    const map = {
        0: "Brown",
        1: "Hancock",
        2: "Johnson",
        3: "Lawrence",
        4: "Marion",
        5: "Monroe",
        6: "Morgan",
        7: "Shelby"
    }

    return map[value] ?? value;
}

export const handleFrequency = (value) => {
    switch(value){
        case 0:
            return '1 x Month';
        case 1:
            return '2 x Month';
        case 2:
            return '1 x Week';
        case 3:
            return '1 x Quarter';
        case 4:
            return '1 x Only';
        case 5:
            return 'Every Other Week';                    
    }
}

export const handleFrequencyMinutes = (value) => {
    switch(value){
        case 30:
            return '30 Minutes';
        case 45:
            return '45 Minutes';
        case 60:
            return '60 Minutes';
        case 90:
            return '90 Minutes';                   
    }
}

export const exportToCSV = (filename, data, options = {}) => {
    if (!data || data.length === 0) return;

    const {
        exclude = [],
        transforms = {}
    } = options

    const renameMap = {
        dob: "Date of Birth",
        spoe: "SPOE",
        ifspNumber: "IFSP Number",
        ifspDate: "IFSP Date",
        falamChin: "Falam",
        hakhaChin: "Hakha",
        matuChin: "Matu",
        tedimChin: "Tedim",
        zopheiChin: "Zophie",
        filipino: "Tagalog",
        frenchCajun: "Hindi",
    };

    const camelToTitle = str => str .replace(/([a-z])([A-Z])/g, '$1 $2') 
        .replace(/([A-Za-z])([0-9])/g, '$1 $2')  
        .replace(/([0-9])([A-Za-z])/g, '$1 $2') 
        .replace(/^./, s => s.toUpperCase());

    const booleanTransform = value => {
        if(value === true) return "Yes";
        if(value === false) return "No";
        return value;
    };

    const transformedData = data.map(row => {
        const newRow = {};
        Object.keys(row).forEach(key => {
            if(exclude.includes(key)) return;

            const value = row[key];

            if(transforms[key]) {
                newRow[key] = transforms[key](value, row);
                return;
            }

            if(typeof value === 'boolean') {
                newRow[key] = booleanTransform(value);
                return;
            }

            newRow[key] = value;
        });

        return newRow;
    })

    const keys = Object.keys(transformedData[0]);

    const headers = keys.map(key => renameMap[key] || camelToTitle(key));
    console.log(headers);

    const rows = transformedData.map(row => keys.map(key => row[key]));

    const csv = Papa.unparse({
        fields: headers,
        data: rows
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const splitName = (fullName) => {
        console.log("full name 2", fullName);
        if(typeof fullName !== "string") {
            return { firstName: "", lastName: "" };
        }

        const trimmmed = fullName.trim();
        if(!trimmmed) {
            return { firstName: "", lastName: "" };
        }

        const [first, ...rest] = trimmmed?.split(/\s+/);

        return {
            firstName: first || "",
            lastName: rest.join(" ") || ""
        };
    };

export const applyNameToForm = (setFormContext, section, fullName) => {
    if (typeof setFormContext !== "function") return;
    if (!section) return;

    // If no name was provided, clear the section entirely
    if (!fullName || fullName.trim() === "") {
        setFormContext(prev => ({
            ...prev,
            [section]: null
        }));
        return;
    }

    const { firstName, lastName } = splitName(fullName);

    setFormContext(prev => ({
        ...prev,
        [section]: {
            preferredName: firstName,
            lastName: lastName
        }
    }));
};

export const uploadPdfForRecord = async (record, file, docType) => {
    if(!record?.firstStepsId) {
        message.error("Record does not contain a First Steps ID");
        return;
    }

    if(!file) {
        message.error("No file selected");
        return;
    }

    if(!docType) {
        message.error("Please select a document type");
        return;
    }

    const firstStepsId = record.firstStepsId;
    const key = `documents/${firstStepsId}/${docType}/${file.name}`;

    try {
        await uploadData({
            key, 
            data: file, 
            options: {
            contentType: "application/pdf"
            }
        }).result;

        message.success("PDF uploaded successfully");
    } catch (err) {
        console.error(err);
        message.error("Upload failed");
    }
};